<script>
import { store } from '../../functions/mixins';
import UiHeadline from '../ui/Headline';
import UiSubheader from '../ui/Subheader';
import UiStepper from '../ui/Stepper';
import UiLoading from '../ui/Loading';
import UiScrollbar from '../ui/Scrollbar';
import UiButton from '../ui/Button';
import deepEqual from 'deep-equal';
import {
    pressengerControl, getNotificationImageURL, getIOSAppleWatchURL, getIOSExtendedNotificationURL, getStudioImageURL,
} from '../../functions/sdk';
import * as crossPopup from '../../functions/crossPopup';
import moment from 'moment';
import { getExtension } from '../../functions/mime';

export default {
    mixins: [store],
    props: {
        value: Object,
        next: Function,
    },
    components: {
        UiHeadline,
        UiSubheader,
        UiLoading,
        UiScrollbar,
        UiButton,
    },
    data: () => ({
        data: null,
        items: [],
        loading: false,
        uploading: false,
        uploadError: false,
        uploadDuplicateFilename: false,
        studioId: 0,
    }),
    computed: {
        sorted() {
            return this.items === null ? [] : this.items.sort((a, b) => {
                const aid = a.id === null ? Number.MAX_SAFE_INTEGER : a.id;
                const bid = b.id === null ? Number.MAX_SAFE_INTEGER : b.id;
                return bid - aid;
            });
        },
    },
    created() {
        this.data = Object.assign({}, this.value);
        this.fetch();
    },
    methods: {
        fetch() {
            this.loading = true;
            pressengerControl.getiOSLogos().then(items => {
                this.items = items.filter(i => i.fileName.indexOf('-2nd') > -1);
                this.loading = false;
            }).catch(() => {
                setTimeout(() => {
                    this.fetch();
                }, 2000);
            });
        },
        openStudio() {
            if (!this.studioId) {
                document.documentElement.scrollTop = 0;
                document.body.className = 'DisableScrolling';
                this.studioId = crossPopup.openIframe(crossPopup.getStudioUrl(886, 759), (type, payload, ID) => {
                    switch (type) {
                        case 'IMAGE_UPLOAD':
                            const blob = new Blob(payload.parts, payload.options);
                            const file = new File([blob], `${Date.now()}-2nd-studio_${moment().format('MMDDYY_HHmmss')}.png`);
                            pressengerControl.uploadiOSLogo(file).then(uploaded => {
                                this.items.push(uploaded);
                                this.data.iosExtendedVisualNotification = uploaded;
                                this.$emit('input', Object.assign({}, this.data));
                                crossPopup.closeAllInstances();
                                this.next();
                            }).catch(() => {
                                crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                    success: false,
                                    url: false,
                                });
                            });
                            break;
                        case 'GET_STUDIO_IMAGES':
                            pressengerControl.getStudioImages().then(result => {
                                crossPopup.dispatch(ID, 'GET_STUDIO_IMAGES_DONE', {
                                    success: true,
                                    images: result.map(i => Object.assign({url: getStudioImageURL(i.groupId, i.fileName)}, i)),
                                });
                            }).catch(() => {
                                crossPopup.dispatch(ID, 'GET_STUDIO_IMAGES_DONE', {
                                    success: false,
                                });
                            });
                            break;
                        case 'UPLOAD_STUDIO_IMAGE': {
                            const ext = getExtension(payload.options.type);
                            if (ext) {
                                const blob = new Blob(payload.parts, payload.options);
                                const file = new File([blob], `${Date.now()}-studio_${moment().format('MMDDYY_HHmmss')}.${ext}`);
                                pressengerControl.uploadStudioImage(file).then(uploaded => {
                                    crossPopup.dispatch(ID, 'UPLOAD_STUDIO_IMAGE_DONE', {
                                        success: true,
                                        image: Object.assign({url: getStudioImageURL(uploaded.groupId, uploaded.fileName)}, uploaded),
                                    });
                                }).catch((e) => {
                                    crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                        success: false,
                                    });
                                });
                            } else {
                                crossPopup.dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                    success: false,
                                });
                            }
                            break;
                        }
                        case 'DELETE_STUDIO_IMAGE':
                            pressengerControl.deleteStudioImage(payload.fileName).then(result => {
                                crossPopup.dispatch(ID, 'DELETE_STUDIO_IMAGE_DONE', {
                                    success: true,
                                    fileName: payload.fileName,
                                });
                            }).catch(() => {
                                crossPopup.dispatch(ID, 'DELETE_STUDIO_IMAGE_DONE', {
                                    success: false,
                                });
                            });
                            break;
                        case 'END':
                            crossPopup.closeAllInstances();
                            document.body.className = '';
                    }
                }, (this.isPushwize || this.isInflugamers) ? 'Studio StudioFull' : 'Studio');
            }
        },
        closeStudio() {
            if (this.studioId) {
                this.studioId = 0;
                crossPopup.closeAllInstances();
                document.body.className = '';
            }
        },
        saveStudio() {
            if (this.studioId) {
                crossPopup.dispatch(this.studioId, 'REQUEST_SAVE');
            }
        },
        upload(event) {
            this.uploadError = false;
            this.uploadDuplicateFilename = false;
            const files = event.target.files || event.dataTransfer.files;
            if (!files || !files[0]) {
                return;
            }
            if (this.checkIsDuplicateFilename(files[0].name.replace(/[^\w.-]+/g, '_'))) {
                this.uploadError = true;
                this.uploadDuplicateFilename = true;
                return;
            }
            const image = new File([files[0]], `${Date.now()}-2nd-${files[0].name.replace(/[^\w.-]+/g, '_')}`)
            this.uploading = true;
            pressengerControl.uploadiOSLogo(image).then(uploaded => {
                this.data.iosExtendedVisualNotification = uploaded;
                this.items.push(uploaded);
            }).catch(() => {
                this.uploadError = true;
            }).finally(() => {
                this.uploading = false;
            });
        },
        select(item) {
            if (this.data.iosExtendedVisualNotification && this.data.iosExtendedVisualNotification.id === item.id) {
                this.data.iosExtendedVisualNotification = null;
            } else {
                this.data.iosExtendedVisualNotification = item;
            }
            //this.data.iosAppleWatch = null;
        },
        getImageSrc(item) {
            return getIOSExtendedNotificationURL(item.groupId, item.fileName); // TODO:
        },
        onPrevClicked() {
            if (this.loading || this.items.length === 0) {
                return;
            }
            if (this.data.iosExtendedVisaulNotification === null) {
                this.data.iosExtendedVisaulNotification = this.sorted[0];
                return;
            }
            let index = 0;
            this.sorted.forEach((item, i) => {
                if (item.id === this.data.iosExtendedVisaulNotification.id) {
                    index = i;
                }
            });
            index--;
            if (index < 0) {
                index = this.sorted.length - 1;
            }
            this.data.iosExtendedVisaulNotification = this.sorted[index];
        },
        onNextClicked() {
            if (this.loading || this.items.length === 0) {
                return;
            }
            if (this.data.iosExtendedVisualNotification === null) {
                this.data.iosExtendedVisualNotification = this.sorted[0];
                return;
            }
            let index = 0;
            this.sorted.forEach((item, i) => {
                if (item.id === this.data.iosExtendedVisualNotification.id) {
                    index = i;
                }
            });
            index++;
            if (index >= this.sorted.length) {
                index = 0;
            }
            this.data.iosExtendedVisualNotification = this.sorted[index];
        },
        friendlyName(filename, trimExt = true) {
            let name = filename;
            const prefix = name.match(/^[0-9]+-+/gi);
            const ext = name.match(/.[a-z]+$/gi);
            if (prefix) {
                name = name.substring(prefix[0].length);
            }
            if (trimExt, ext) {
                name = name.substring(0, name.length - ext[0].length)
            }
            return name;
        },
        checkIsDuplicateFilename(filename) {
            const ffn = this.friendlyName(filename)
            return !!this.items.find(i => this.friendlyName(i.fileName) === ffn);
        },
    },
    destroyed() {
        // crossPopup.closeAllInstances();
        document.body.className = '';
    },
    watch: {
        value: {
            deep: true,
            handler(nextVal) {
                if (!deepEqual(nextVal, this.data)) {
                    this.data = Object.assign({}, nextVal);
                }
            }
        },
        data: {
            deep: true,
            handler: function(nextVal) {
                if (!deepEqual(nextVal, this.value)) {
                    this.$emit('input', Object.assign({}, nextVal));
                }
            }
        },
    },
}
</script>

<template>
    <div class="StepTransitions">
        <ui-loading v-if="loading || uploading" />
        <template v-else>
            <div class="Grid" style="padding-right: 20px; margin-bottom: 50px;">
                <div class="GridItem StudioButton DisableHover" @click="openStudio()" v-if="!isStudioDisabled">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper"></div>
                </div>
                <div :class="['GridItem', 'UploadButton', 'NoBorderLeft', 'DisableHover', {Error: uploadError}]" @click="$refs.uploader.click()" v-if="!isUploadDisabled">
                    <div class="Toolbar">
                        <span>&nbsp;</span>
                    </div>
                    <div class="ImageWrapper">
                        <span class="GridItemErrorMessage" v-if="uploadDuplicateFilename">{{ $t('sendPressageView.uploadErrorDuplicateFilename') }}</span>
                    </div>
                    <div class="GridItemHint" v-html="$t('sendPressageView.stepIOSExtendedNotificationUploadHint')" />
                </div>
                <div
                    :class="{
                        GridItem: true,
                        Active: data.iosExtendedVisualNotification && '[use-bubble]' === data.iosExtendedVisualNotification.id,
                        NoBorderLeft: true,
                        UseBubbleButton: true,
                        DisableHover: true,
                    }"
                    @click="select({id: '[use-bubble]'})"
                    v-if="data.bubble"
                >
                    <div class="Toolbar"><span>&nbsp;</span></div>
                    <div class="ImageWrapper"></div>
                    <div class="Check">
                        <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
                    </div>
                    <div class="GridItemHint" v-html="$t('sendPressageView.stepIOSExtendedNotificationUseBubbleHint')" />
                </div>
            </div>
            <ui-scrollbar :height="220">
                <div class="Grid">
                    <div
                        v-for="(i, index) in sorted"
                        :class="{
                            GridItem: true,
                            Active: data.iosExtendedVisualNotification && i.id === data.iosExtendedVisualNotification.id,
                            NoBorderLeft: index % 4 !== 0,
                            NoBorderTop: index > 3,
                        }"
                        :key="i.id"
                        @click="select(i)"
                    >
                        <div class="Toolbar">
                            <span>{{ friendlyName(i.fileName) }}</span>
                        </div>
                        <div class="ImageWrapper">
                            <video v-if="getImageSrc(i).split('.').pop().toLowerCase() === 'mp4'" autoplay loop>
                                <source :src="getImageSrc(i)" type="video/mp4">
                                <span>Video not supported.</span>
                            </video>
                            <img v-else :src="getImageSrc(i)" :alt="friendlyName(i.fileName)" />
                        </div>
                        <div class="Check">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="16.5" height="13.5" viewBox="0 0 16.5 13.5" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.038 2.741c.298-.305.462-.708.462-1.133 0-.43-.164-.833-.462-1.138a1.55 1.55 0 00-2.222 0L4.869 9.616 2.684 7.385a1.548 1.548 0 00-2.222 0A1.614 1.614 0 000 8.522c0 .429.164.832.462 1.133l3.293 3.365a1.55 1.55 0 002.222 0"/></svg>
                        </div>
                    </div>
                    <div class="GridFullLoading" v-if="uploading">
                        <ui-loading />
                    </div>
                </div>
            </ui-scrollbar>
        </template>
        <div class="StudioControls" v-if="studioId">
            <div class="Back">
                <ui-button @click.native="closeStudio()" class="clear">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="15" height="14.969" viewBox="0 0 15 14.969" v-bind:svg-inline="''" v-bind:class="'mr-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.313 7.452l5.361 5.633c.41.431.41 1.129 0 1.56a1.014 1.014 0 01-1.485 0L7.728 8.906c-.093.029-.187.059-.284.059-.073 0-.143-.028-.215-.044l-5.447 5.724a1.014 1.014 0 01-1.485 0 1.145 1.145 0 010-1.56l5.32-5.59L.279 1.868a1.145 1.145 0 010-1.56 1.01 1.01 0 011.48 0l5.443 5.739c.094-.028.187-.059.283-.059.073 0 .143.028.215.044L13.13.308a1.01 1.01 0 011.48 0 1.147 1.147 0 010 1.56L9.313 7.452z"/></svg>
                    {{ $t('sendPressageView.studioClose') }}
                </ui-button>
            </div>
            <div class="Next">
                <ui-button @click.native="saveStudio()" class="clear">
                    {{ $t('sendPressageView.studioSaveIOSExtVisualNotification') }}
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" width="8.03" height="14" viewBox="0 0 8.03 14" v-bind:svg-inline="''" v-bind:class="'ml-3'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.741 6.305L1.678.283a.993.993 0 00-1.397 0 .977.977 0 000 1.387l5.366 5.328-5.366 5.329a.977.977 0 000 1.387.993.993 0 001.397 0l6.063-6.022a.975.975 0 000-1.387z"/></svg>
                </ui-button>
            </div>
        </div>
        <input
            type="file"
            ref="uploader"
            name="file"
            accept="*"
            style="display: none"
            @change="upload"
        />
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.StudioControls
    position fixed
    bottom 0
    right 0
    left 100px
    background #fff
    z-index 50
    height 100px
    display flex
    align-items center
    justify-content space-between
    overflow hidden
    transition .3s all
    .Back, .Next
        position absolute
        padding 0
        transition .3s all
        .mr-3, .ml-3
            transition .3s all
        &:before, &:after
            content ''
            position absolute
            transition .3s all
        &:before
            width 1px
            background $cBorder
            top -100px
            bottom -100px
        &:after
            width 3px
            background $cAccent
            top 5px
            bottom 5px
        &:hover:after
            width 7px
    .Next
        right 0
    .Back:before
        right 0
    .Back:after
        right -1px
    .Next:before
        left 0
    .Next:after
        left -1px
    .Back:hover
        &:after
            right -3px
        .mr-3
            transform translate(-20px,0)
    .Next:hover
        &:after
            left -3px
        .ml-3
            transform translate(20px,0)

.Grid
    display flex
    justify-content flex-start
    align-items flex-start
    align-content flex-start
    flex-wrap wrap
    min-height 100%
    box-sizing border-box
    position relative
    .GridItem
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 25%
        position relative
        border 1px solid $cBorder
        box-sizing border-box
        padding 20px
        transition .3s all
        background rgba(255,255,255,.4)
        cursor: pointer
        &.StudioButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/studio_square.png)
            background-size contain
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
        &.UploadButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/upload_transparent.png)
            background-size 64px
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
            &.Error
                background-color $cError
        &.UseBubbleButton
            background-color #2B2A62
            background-image url(/static/img/toolbox2/usebubble_square.png)
            background-size cover
            background-repeat no-repeat
            background-position center center
            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .3s all;
                background: rgba(255,255,255,0);
            }
            &:hover::after {
                background: rgba(255,255,255,.05);
            }
        &.NoBorderTop
            border-top none
        &.NoBorderLeft
            border-left none
        .Toolbar
            font-size 12px
            font-weight 600
            color $cPrimary
            align-self flex-start
            overflow hidden
            white-space nowrap
            max-width 100%
        .ImageWrapper
            overflow hidden
            height 110px
            display flex
            flex-direction column
            justify-content center
            align-items center
            img, video
                max-width 100%
                max-height 110px
            span
                font-weight bold
                font-size 14px
                color $cPrimary
            .GridItemErrorMessage
                display inline-block
                margin-top 20px
                font-weight 500
                font-size 12px
                text-align center
                transition .3s all
            .GridItemUploadImage
                width 100%
                height 100%
                max-width 32px
                max-height 32px
                fill: $cPrimary
                transition .3s all
        .Check
            position absolute
            opacity 0
            top 0
            left 0
            right 0
            bottom 0
            background rgba(255,255,255,.7)
            display flex
            align-items center
            justify-content center
            transition .3s all
            svg
                transform scale(2)
            path
                fill $cAccent
        .GridItemHint
            position absolute
            padding 20px
            background #fff
            border 2px solid $cBorder
            color $cPrimary
            font-size 12px
            font-weight 400
            transform: translate(-50%, -50%) scale(0);
            transition .3s all
            z-index 9999
            left: 50%;
            top: 100%;
            width: calc(100% - 40px);
            min-width 300px
        &:hover
            .GridItemHint
                transform: translate(-50%, 0) scale(1);
        &.Active
            background-color #fff
            transform scale(1.08)
            z-index 2
            border-color white
            box-shadow 0 40px 100px rgba(0,0,0,.2)
            .Check
                opacity 1
            img
                filter blur(3px)
            &.UseBubbleButton
                border-color #C0BFD0
        &.Error
            .ImageWrapper
                .GridItemErrorMessage
                    color $cError
                .GridItemUploadImage
                    fill $cError
        &:hover:not(.DisableHover)
            background #fff
    .GridFullLoading
        position absolute
        width 100%
        height 100%
        background rgba(255,255,255,.4)
        display flex
        align-items center
        justify-content center
        z-index 10
    &.ColumnHalf
        .GridItem
            width 50%
            .ImageWrapper
                height 80px
            .ImageWrapper img
                max-height 80px
                max-width 1000px

.StepTransitions .Scrollbar
    padding 40px 70px 150px 70px !important
    margin -40px -50px -150px -70px
    .ps__scrollbar-y-rail
        right 50px !important
        top 50px !important
</style>
